<template>
  <section v-if="content !== null" v-html="content" :class="sectionClass">
  </section>
  <section v-else :class="sectionClass">
    <slot></slot>
  </section>
</template>
<script>
  import axios from 'axios';
  import UUIDMixin from '../../utilities/UUIDMixin';
  import marked from 'marked';
  import DOMPurify from 'dompurify';

  export default {
    name: 'CustomSection',
    mixins: [UUIDMixin],
    props: {
      source: {type: String, required: true},
      sectionClass: {type: String, default: ''},
    },
    data() {
      return {content: ''};
    },
    methods: {
      removeStyle() {
        const styleElement = document.getElementById(`custom-section-style-${this.uuid}`);
        if (styleElement) {
          document.head.removeChild(styleElement);
        }
      },
      async updateContent() {
        // load styles if available
        const linkElement = document.createElement('link');
        linkElement.id = `custom-section-style-${this.uuid}`;
        linkElement.rel = 'stylesheet';
        linkElement.type = 'text/css';
        linkElement.href = `./static/${this.source}.css`;
        document.head.appendChild(linkElement);
        // load content
        try {
          const response = await axios.get(`./static/${this.source}.html`);
          this.content = response.data;
        } catch (e) {
          if (e.response.status !== 404) {
            this.content = null;
            return;
          }
          try {
            const response = await axios.get(`./static/${this.source}.md`);
            this.content = DOMPurify.sanitize(marked(response.data));
          } catch (e) {
            this.content = null;
          }
        }
      },
    },
    beforeMount() {
      this.updateContent();
    },
    beforeDestroy() {
      this.removeStyle();
    },
    watch: {
      source() {
        this.removeStyle();
        this.updateContent();
      },
    },
  };
</script>
